export default {
    inserted(el, binding) {
      const originalText = el.innerText; // 保存原始按钮文字
      let timeoutId = null; // 用于存储定时器ID
      // 手动恢复按钮状态的方法
      el.resetButton = () => {
        console.log('手动恢复按钮状态');
        if (timeoutId) {
          clearTimeout(timeoutId); // 清除定时器
        }
        el.disabled = false;
        el.innerText = originalText; // 恢复按钮文字
      };
      // 如果enabled为false，则不启用防重复点击功能
      if (binding.value && binding.value.enabled !== false) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true;
            el.innerText = '提交中...'; // 修改按钮文字
            timeoutId = setTimeout(() => {
              el.resetButton(); // 自动恢复
            }, (binding.value && binding.value.delay) || 5000); // 默认5秒后恢复
          }
        });
      }
    }
  };